import { TooltipProvider } from '@/components/ui/tooltip';
import { TypographyShowcase } from '@/components/TypographyShowcase';
import { ButtonsSection } from './ButtonsSection';
import { FormSection } from './FormSection';
import { DisplaySection } from './DisplaySection';
import { InteractiveSection } from './InteractiveSection';
import { AlertsSection } from './AlertsSection';
import { TabsSection } from './TabsSection';
import { AccordionSection } from './AccordionSection';
import { TableSection } from './TableSection';
import { SkeletonSection } from './SkeletonSection';
import { SeparatorSection } from './SeparatorSection';

function ComponentsPage() {
  return (
    <TooltipProvider>
      <div className='min-h-screen bg-background'>
        <div className='container mx-auto px-4 py-8'>
          {/* Header */}
          <div className='text-center mb-12'>
            <h1 className='text-h1 mb-4'>SWD Design System & Component Showcase</h1>
            <p className='text-body-2 text-muted-foreground'>
              Das SWD Design System mit Typografie, Farben und allen verfügbaren UI-Komponenten
            </p>
          </div>

          <TypographyShowcase />

          <div className='mt-16'>
            <h2 className='text-h2 text-center mb-8'>shadcn/ui Components</h2>

            <ButtonsSection />

            <FormSection />

            <DisplaySection />

            <InteractiveSection />

            <AlertsSection />

            <TabsSection />

            <AccordionSection />

            <TableSection />

            <SkeletonSection />

            <SeparatorSection />

            {/* Footer */}
            <div className='text-center text-muted-foreground mt-16'>
              <p className='text-body-2'>
                Built with SWD Design System, shadcn/ui components • React + TypeScript + Tailwind CSS
              </p>
            </div>
          </div>
        </div>
      </div>
    </TooltipProvider>
  );
}

export default ComponentsPage;
